import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TidyUiComponentsModule } from 'src/tidy-ui-components/tidy-ui-components.module';

/**
 * A single KPI tile (icon + label + value) for the Overview / Property P&L
 * `.kpi-row`. The host carries the `.kpi-card` class so the KPI-tile styling
 * defined by the strategy page (card shell, `.kpi-icon` color classes,
 * `.kpi-label` / `.kpi-value` typography) applies — the caller passes a
 * pre-formatted `value` string, keeping formatting out of the template.
 */
@Component({
  selector: 'tidy-kpi-tile',
  templateUrl: './kpi-tile.component.html',
  standalone: true,
  imports: [CommonModule, TidyUiComponentsModule],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'kpi-card' },
})
export class KpiTileComponent {
  /** Uppercase helper label, e.g. "Avg Star Rating". */
  readonly label = input.required<string>();
  /** Pre-formatted value, e.g. "$2198", "97%", "12 min". */
  readonly value = input.required<string>();
  /** SVG asset path for the icon. */
  readonly icon = input.required<string>();
  /** Icon color class, e.g. "icon-revenue" / "icon-rating". */
  readonly colorClass = input<string>('');
  /** Optional scope note under the value, e.g. "All Properties" for an account-wide metric. */
  readonly caption = input<string>('');
}
